import { isBefore, addSeconds } from 'date-fns';

/**
 * A helper class to expire the items stored in the
 * map after the desired amount of seconds. This will
 * return null if the item has expired. Mostly designed
 * for dataloader
 */
export class ExpiryMap<K, V> extends Map<K, any> {
  constructor(protected expiryInSeconds = 60) {
    super();
  }
  /**
   * Get the value for the given key. This returns null if,
   * the value does not exist or is expired.
   * @param key The key to get
   */
  get(key: K): V {
    const fromMemory = super.get(key);
    if (fromMemory) {
      const { expiryTime, value } = fromMemory;
      if (isBefore(Date.now(), expiryTime)) {
        return value;
      }
      this.delete(key);
    }
  }
  /**
   * Stores the value against the given key.
   * The items will expire after the given amount of time.
   */
  set(key: K, value: V) {
    super.set(key, { value, expiryTime: addSeconds(Date.now(), this.expiryInSeconds) });
    return this;
  }
}
